import { render } from "./Quotation.vue?vue&type=template&id=c9983836&scoped=true"
import script from "./Quotation.vue?vue&type=script&lang=js"
export * from "./Quotation.vue?vue&type=script&lang=js"

import "./Quotation.vue?vue&type=style&index=0&id=c9983836&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c9983836"

export default script